import axios from 'axios';
import { getDeviceInfoSimple } from '@/assets/js/base';
import { getAuthToken, getAuthUserInfo } from '@/utils/authStorage';

axios.defaults.timeout = 15000

/**
 * request 拦截器：自动注入 token、userId、appVersion、channel
 */
axios.interceptors.request.use(
    config => {
        // 本地无登录信息时从安卓原生恢复（与 authStorage 一致）
        const token = getAuthToken()
        const userInfo = getAuthUserInfo()
        const userId = userInfo?.userId || userInfo?.userid || userInfo?.id || ''

        config.headers = {
            'access-token': token,
            'orginChannel': 'sdk',
        };

        const deviceInfo = getDeviceInfoSimple()
        const commonParams = {
            appVersion: deviceInfo.appVersion,
            channel: deviceInfo.channel,
        }
        if (userId) {
            commonParams.userId = userId
        }

        if (config.method === 'get') {
            config.params = Object.assign({}, commonParams, config.params)
        } else if (config.method === 'post') {
            config.data = Object.assign({}, commonParams, config.data)
        }

        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

/**
 * 响应拦截器即异常处理
 * */
axios.interceptors.response.use(response => {
    if (response?.data?.code === 100002) {
        response.data.message = '登录已过期，请重新登录，请在我的页面下滑找到退出登录，重新登录'
    }
    return response
}, err => {
    if (err.message.includes('timeout')) {
        console.log('')
    }

    if (err && err.response) {
        console.log('')
    } else {
        console.log('')
    }

    return Promise.resolve(err.response)
})

export function get(url, params = {}) {
    return new Promise((resolve, reject) => {
        axios.get(url, {params: params}).then(response => {
            resolve(response.data);
        }).catch(err => {
            reject(err)
        })
    })
}

export function getForm(url, params = {}) {
    return new Promise((resolve, reject) => {
        axios.post(url, {
            params: params,
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        }).then(response => {
            resolve(response.data);
        }).catch(err => {
            reject(err)
        })
    })
}

/**
 * POST + application/x-www-form-urlencoded
 * 说明：请求体会与拦截器中的 commonParams 合并后，再序列化为 x-www-form-urlencoded 字符串
 * @param {string} url 完整请求地址
 * @param {Record<string, unknown>} data 业务入参（可为空对象）
 */
export function postForm(url, data = {}) {
    return new Promise((resolve, reject) => {
        axios
            .post(url, data, {
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                transformRequest: [
                    (body) => {
                        if (body == null) return ''
                        if (typeof body === 'string') return body
                        if (typeof body !== 'object') return String(body)
                        return Object.keys(body)
                            .filter((k) => body[k] !== undefined && body[k] !== null)
                            .map((k) => `${encodeURIComponent(k)}=${encodeURIComponent(String(body[k]))}`)
                            .join('&')
                    },
                ],
            })
            .then((response) => {
                resolve(response.data)
            })
            .catch((err) => {
                reject(err)
            })
    })
}

export function post(url, data) {
    return new Promise((resolve, reject) => {
        axios.post(url, data, {}).then(response => {
            resolve(response.data);
        }, err => {
            reject(err)
        })
    })
}
